module.exports = __webpack_public_path__ + "img/arrow-down-blue.3c903ffb.svg";